module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAASBJREFUaEPtWd0RgjAMbvfQLfBBDgdwEYdyEQeQgwfZQveoxx31oXehoQ21hY/nkOT7SVoOrQp/dOH9KwD4t4JQIFsF2v51NUbftVIHySaNUh+tza05nx4SeUkLPbvhLd28bXgEcamr46oA2m4wEgWoHE1dicwfmWRzAGIZcwmJzWeVZSsQWxAAiGHarwK+IXctl52FACD1OeCzhDtjvvjYrZbdGqUs6bs7ZbOF5mZq7u5UBIDRLpTl9gtg7TXKPTeCFQAAzzkABbgMcL/alubjxgfPALdxG8dtaGk8AHCVgALE1oKFYCGCAe7MwEKwECw0MeC7HnOtkirOfqH9hhgAUlE/1dmeAokJFCsn8ptHrJuARAAQQJroK1BAlM6AZF/O5n5AC4CiJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ld.png
// module id = +y5k
// module chunks = 0